import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BootstrapInput } from "./bootstrapInput";
import { useComponentVisible } from "./outSideClick";

const Receiver = (props) => {
  const { t } = useTranslation();
  const [addressDropdown, setAddressDropdown] = useState(false);
  const { ref, isComponentVisible } = useComponentVisible(true);
  const {
    ReceiverAddress,
    contentList,
    AddressError,
    onChangeAmount,
    amountError,
    amountFocusout,
    amountWithCommas,
    setReceiverAddress,
  } = props;

  useEffect(() => {
    setTimeout(() => {
      if (!isComponentVisible) {
        setAddressDropdown(false);
      }
    });
  }, [isComponentVisible]);

  const onAddressDropdownClick = () => {
    if (addressDropdown) {
      setAddressDropdown(false);
    } else {
      setAddressDropdown(true);
    }
  };

  // Method to set ReceiverAddress
  const onChangeReceiverAddress = (value) => {
    setReceiverAddress(value);
  };

  const onChangeReceiverAddress2 = (publicKey) => {
    setReceiverAddress(publicKey);
  };

  return (
    <div className="TableBg cardBg">
      <div className="ContHeader pendingTable">
        <h3>{t("Receiver")}</h3>
      </div>
      <div className="ReceiveInput">
        <div className="addressInput">
          <div className="custom_select_container">
            <div
              ref={ref}
              className="selected_address"
              onClick={onAddressDropdownClick}
            >
              <FormControl fullWidth>
                <InputLabel shrink htmlFor="demo-customized-textbox">
                  {t("Address")}
                </InputLabel>
                <BootstrapInput
                  id="demo-customized-textbox"
                  autoComplete="off"
                  value={ReceiverAddress}
                  onChange={(e) => {
                    onChangeReceiverAddress(e.target.value);
                    setAddressDropdown(false);
                  }}
                  fullWidth
                />
              </FormControl>
              {addressDropdown ? (
                <ArrowDropUpIcon className="caret" />
              ) : (
                <ArrowDropDownIcon className="caret" />
              )}
            </div>
            {addressDropdown && (
              <div className="options_list">
                <ul>
                  {contentList.length > 0 &&
                    contentList.map((res, index) => (
                      <li
                        onClick={() => {
                          onChangeReceiverAddress2(res.publicKey);
                          setAddressDropdown(false);
                        }}
                        key={index}
                      >
                        {res.contactName}
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>
          <span className="validText">{AddressError}</span>
        </div>
        <div className="AmountInput">
          <InputLabel shrink className="mb-0 amountLabel">
            {t("Amount")}
          </InputLabel>
          <NumberFormat
            value={amountWithCommas}
            thousandSeparator={true}
            type="text"
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onChange={onChangeAmount}
            onBlur={(e) => amountFocusout()}
            decimalScale={7}
            // onKeyPress={(evt) => {
            //   NumberFieldValidation(evt) && evt.preventDefault();
            //   onChangeAmount(evt);
            //}}
            placeholder="0"
            allowNegative={false}
            customInput={TextField}
          />
          <span className="boa">BOA</span>
          <span className="validText">{amountError}</span>
        </div>
      </div>
    </div>
  );
};
export default Receiver;
